module.exports = __webpack_public_path__ + "img/ventas-management.ca3def52.png";